import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { UnknownError } from '@cian/peperrors';

import { fetchGetLkType, TGetLkTypeResponse } from '../../repositories/lk-type/v2/get-lk-type';
import { TUserRole } from '../../types/currentUser';

interface IDependencies {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
  cookie?: string;
}

export async function resolveUserRole({ cookie, httpApi, logger }: IDependencies): Promise<TUserRole> {
  try {
    const result = (await fetchGetLkType({
      httpApi,
      config: cookie ? { requestConfig: { headers: [['cookie', cookie]] } } : undefined,
    })) as TGetLkTypeResponse;

    if (result.statusCode !== 200) {
      return null;
    }

    return result.response.lkType;
  } catch (error) {
    logger.error(error as UnknownError, {
      message: (error as UnknownError).message,
      stack: (error as UnknownError).stack,
      comment: 'Ошибка запроса в get-lk-type',
    });

    return null;
  }
}
